
import { useLocation } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import { ReactNode } from "react";

interface LayoutProps {
  children: ReactNode;
  hideNav?: boolean;
  bottomPadding?: boolean;
}

export const Layout = ({
  children,
  hideNav = false,
  bottomPadding = true
}: LayoutProps) => {
  const location = useLocation();
  const isCreateEventFlow = location.pathname === '/create-event' || location.pathname === '/invite-guests';
  const isEventDetailsPage = location.pathname.startsWith('/events/') && !location.pathname.includes('/details');
  const shouldHideNav = hideNav || isCreateEventFlow || isEventDetailsPage;
  
  return <div className={`min-h-screen bg-background ${bottomPadding ? 'pb-16' : ''}`}>
      <div className="relative">
        {children}
      </div>
      {!shouldHideNav && <BottomNav />}
    </div>;
};
